// extracted by mini-css-extract-plugin
export var addToCartButton = "_sy-b";
export var arrowButtonContainer = "_sy-9";
export var arrowButtonIcon = "_sy-a";
export var carouselArrowButton = "_sy-6";
export var carouselElementContainer = "_sy-1";
export var galleryThumbnail = "_sy-d";
export var galleryThumbnailImage = "_sy-e";
export var left = "_sy-7";
export var productDisplayCarouselContainer = "_sy-0";
export var productTileContainer = "_sy-2";
export var productTileImage = "_sy-4";
export var productTileImageContainer = "_sy-3";
export var productTileTitle = "_sy-5";
export var right = "_sy-8";
export var sliderOverflow = "_sy-c";